var dataMap = {
    informations: [
        {
            label: Loc.g('Nom de l’opportunité'),
            id: 'name',
            format: 'text',
        },
        {
            label: Loc.g('Montant potentiel'),
            id: 'potentialAmount',
            format: 'text',
            isCurrency: true,
        },
        {
            label: Loc.g('Pipeline'),
            id: 'funnelName',
            format: 'text',
        },
        {
            label: Loc.g('Etape'),
            id: 'stepName',
            format: 'text',
        },
        {
            label: Loc.g('Dans l’étape depuis'),
            id: 'stepEnterDate',
            format: 'days',
        },
        {
            label: Loc.g('Identifiant'),
            id: 'ident',
            format: 'text',
        },
        {
            label: Loc.g("Date d'échéance"),
            id: 'dueDate',
            format: 'date',
        },
        {
            label: Loc.g('Date de création'),
            id: 'createdDate',
            format: 'date',
        },
        {
            label: Loc.g('Source'),
            id: 'sourceName',
            format: 'text',
        },
        {
            label: Loc.g('Note'),
            id: 'brief',
            format: 'textarea',
        },
    ],
    third: [
        {
            label: Loc.g('Nom'),
            id: 'name',
            format: 'link',
        },
        {
            label: Loc.g('Localisation'),
            id: 'city',
            format: 'text',
        },
        {
            label: Loc.g('Téléphone'),
            id: 'phone',
            format: 'phone',
        },
        {
            label: Loc.g('Mobile'),
            id: 'mobile',
            format: 'phone',
        },
        {
            label: Loc.g('Email'),
            id: 'email',
            format: 'email',
        },
        {
            label: Loc.g('Site web'),
            id: 'web',
            format: 'external_url',
        },
    ],
    contacts: [
        {
            label: Loc.g('Nom contact'),
            id: 'fullName',
            format: 'link',
        },
        {
            label: Loc.g('Localisation'),
            id: 'city',
            format: 'text',
        },
        {
            label: Loc.g('Téléphone'),
            id: 'phone',
            format: 'phone',
        },
        {
            label: Loc.g('Mobile'),
            id: 'mobile',
            format: 'phone',
        },
        {
            label: Loc.g('Email'),
            id: 'email',
            format: 'email',
        },
    ],
};

var navMap = [
    {
        id: 'informations',
        label: '',
        items: [
            {
                id: 'activity',
                label: Loc.g('Activité'),
                group: false,
                component: 'tab-activity',
                permission: 'can_show_activity',
                databot: 'opp-overview__menu--activity',
                // keepalive: true,
                more: {},
            },
            {
                id: 'pipeline',
                label: Loc.g('Pipeline'),
                group: false,
                component: 'tab-pipeline',
                databot: 'opp-overview__menu--pipeline',
                more: {},
            },

            {
                id: 'informations',
                label: Loc.g('Informations générales'),
                group: false,
                component: 'tab-informations-opportunity',
                databot: 'opp-overview__menu--general-info',
                more: {},
            },
            {
                id: 'documents',
                label: Loc.g('Documents liés'),
                group: false,
                component: 'tab-documents',
                permission: 'can_show_invoicing_docs',
                databot: 'opp-overview__menu--doc-linked',
                more: {
                    buttons: [
                        {
                            type: 'js',
                            primary: false,
                            label: Loc.g('Lier un document'),
                            permission: 'can_link_invoicing_docs',
                            callback: 'javascript:Opportunity.linkTo({linkedid})',
                        },
                        {
                            type: 'js',
                            primary: false,
                            label: Loc.g('Créer un document'),
                            permission: 'can_create_invoicing_docs',
                            callback:
                                "javascript:Third.newDoc('{thirdid}', '{relationtype}', 'opportunity', '{linkedid}', 'prospection')",
                        },
                    ],
                },
            },
            {
                id: 'customfields',
                label: Loc.g('Champs personnalisés'),
                group: false,
                component: 'tab-customfields',
                databot: 'opp-overview__menu--cf',
                more: {
                    url: '/rest/prospection/opportunities/{linkedid}/custom-field-values',
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'openCustomfields',
                            params: {},
                        },
                    ],
                },
            },
        ],
    },
    {
        id: 'plugin',
        label: Loc.g('Modules'),
        items: [
            {
                id: 'proposal',
                label: Loc.g('Documents redactor'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_proposal',
                databot: 'opp-overview__menu--doc-redactor',
                more: {
                    title: Loc.g('Documents redactor'),
                    listingname: 'proposal',
                    url: '/?_f=tabs',
                    action: 'loadListingTab',
                    context: 'opportunity',
                    prefilter: '{"oppid": {linkedid}}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un document redactor'),
                            permission: true,
                            callback: "javascript:Proposal.create('propdocument');",
                        },
                    ],
                },
            },
            {
                id: 'briefcase',
                label: Loc.g('Fichiers'),
                group: false,
                component: 'tab-briefcase',
                permission: 'can_show_briefcase',
                databot: 'opp-overview__menu--briefcase',
                more: {
                    title: '',
                    url: '/?_f=briefcasev2',
                    action: 'loadBriefcaseTab',
                    linkedid: '{linkedid}',
                    linkedtype: '{linkedtype}',
                    linkedtypeDir: 'opportunities',
                    linkedname: '{linkedname}',
                    editpermission: 'auto',
                    buttons: [],
                },
            },
        ],
    },
];

var headerActions = [
    {
        label: Loc.g("Modifier l'opportunité"),
        type: 'function',
        value: 'editOpportunity',
        permission: 'can_edit',
    },
    {
        label: Loc.g("Dupliquer l'opportunité"),
        type: 'function',
        value: 'duplicateOpportunity',
        permission: 'can_create',
    },
    {
        label: Loc.g("Supprimer l'opportunité"),
        type: 'js',
        value: 'javascript:Opportunity.confirmDeletion({id})',
        permission: 'can_delete',
    },
    {
        label: Loc.g('Déclarer des heures'),
        type: 'function',
        value: 'addTimetracking',
        permission: 'can_add_timetracking',
    },
    {
        label: Loc.g('Voir le timetracking'),
        type: 'js',
        value: "javascript:Timetracking.viewLinkedTimetracking({id}, 'opportunity')",
        permission: 'can_see_timetracking_history',
    },
];

var panelActions = [
    {
        label: Loc.g('Supprimer'),
        type: 'js',
        value: "javascript:Opportunity.confirmDeletion({id}, '{context}')",
        permission: 'can_delete',
    },
];

var backlink = [
    {
        type: 'opportunity',
        url: '/prospection/opportunities',
        label: Loc.g('Opportunités'),
    },
];

var routes = [
    {
        id: 'activityform',
        value: '/rest/prospection/opportunities/{id}/activity',
    },
    {
        id: 'save',
        value: '/rest/prospection/opportunities/{id}/{type}',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'opportunityActivity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'opportunity'],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'opp-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'opp-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'opp-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'opp-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'opp-overview__activity--call-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'opportunity',
    'task',
    'estimate',
    'propdocument',
];

var forcedLabel = [
    {
        value: 'opportunity',
        label: Loc.g('Mises à jour'),
    },
];

var object = {
    idName: 'opportunityid',
};

var databots = {
    activitycommentadd: 'opp-overview__activity--comment-add',
    emailadd: 'opp-overview__activity--email-add',
    calladd: 'opp-overview__activity--call-add',
    scheduledcalladd: 'opp-overview__activity--scheduled-call-add',
    taskadd: 'opp-overview__activity--task-add',
    eventadd: 'opp-overview__activity--event-add',
    generalinfoedit1: 'opp-overview__section--general-info-edit-1',
    generalinfoedit2: 'opp-overview__section--general-info-edit-2',
};

var agendaViewConfig = {
    relatedtype: 'opportunity',
    nameCallbackFunction: 'Opportunity.loadAgendaTab',
    prefixXsl: 'opp',
};

export {
    dataMap,
    navMap,
    headerActions,
    panelActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    databots,
    agendaViewConfig,
};
